<template>
  <div
    class="com-goods-price-banner-point flex flex-wrap"
    :style="{ 'background-image': `url(${renderBrandElement({ id: 'goodsProfile.priceBannerBg', type: 'image' })})` }"
  >
    <div class="price-info mt1 flex items-start">
      <p class="" style="color: #fff">
        <span class="point fs24">{{ good.goodsDetailEx.costPoints }}</span>
        <span class="price">
          <span class="fs24">{{ globalPointName }}</span>
          <span class="">+{{ good.goodsDetailEx.price }}元</span>
          <span v-if="good.goodsSpecList?.length > 1" class="fs13" style="margin-left: 3px">起</span>
        </span>
        <span class="original-price opacity07">￥{{ good.goodsDetailEx.originalPrice }}</span>
      </p>
    </div>
    <div class="flex justify-between items-center exchange-hot mb1">
      <div class="hot flex flex-none items-center fs12 opacity07">{{ saleDesc }}</div>
      <div class="price-reduce opacity07">
        {{ globalPointName }}已为您节省{{
          Number(good.goodsDetailEx.originalPrice) - Number(good.goodsDetailEx.price)
        }}元
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
// import { ImageThemed, IconFont, CountDown } from 'components'

export default {
  // components: { IconFont, ImageThemed, CountDown },
  props: {
    good: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      timer: undefined,
      countDownEnd: dayjs().endOf('d'),
      dateTime: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
    }
  },

  computed: {
    saleDesc() {
      return _.replace(this.good.goodsDetailEx.saleDesc, '兑换', this.globalExchangeWord)
    }
  },

  created() {},
  beforeDestroy() {},

  methods: {}
}
</script>
<style lang="less" scoped>
.com-goods-price-banner-point {
  height: 60px;
  line-height: 1;
  background-color: #e93829;
  padding: 0 12px;
  box-sizing: border-box;
  position: relative;
  background-size: no-repeat;
  background-size: 100% 100%;
  .price-info {
    width: 100%;
  }
  .exchange-hot {
    width: 100%;
  }
  .hot {
    color: #fff;
  }
  .point {
    color: #fff;
  }
  .price-reduce {
    color: #fff;
    font-size: 12px;
  }
  .price {
    font-size: 15px;
    color: #fff;
  }

  .tag {
    background-color: #fff;
    font-size: 12px;
    color: #e93829;
    border-radius: 5px;
    padding: 5px;
    box-sizing: border-box;
    position: absolute;
    top: 13px;
  }

  .original-price {
    font-size: 15px;
    color: #fff;
    font-weight: 400;
    text-decoration: line-through;
    margin-left: 5px;
  }
}
</style>
